/**
 * A script answered without a code fence: the answer with that script fenced, so the chat
 * renders it as code with "Open on chart" and the evals read it the same way (eval
 * 2026-10-05: 21 of Grok's 22 one-shot misses were a complete script with no fence). No
 * imports: the chat loads this outside the EdgeScript bundle.
 */
const PRAGMA = /^\s*\/\/@edgescript\b/
const FENCE = /^\s*(```|~~~)/

/**
 * A line that reads as a sentence, not code. A statement never ends with a period, so a
 * sentence-case line of four or more words is prose when it ends like a sentence, or when it
 * has no code characters at all; a markdown heading, list item or quote is prose too.
 */
function isProse(line: string): boolean {
  const t = line.trim()
  if (/^(#{1,6}\s|[-*+]\s|>\s|\d+\.\s)/.test(t)) return true
  if (t.startsWith('//') || !/^[A-Z]\S*(\s+\S+){3,}/.test(t)) return false
  return /[.!?:]$/.test(t) || !/[=(){}[\];]/.test(t)
}

export function fenceBareScripts(text: string): string {
  if (!text.includes('//@edgescript')) return text
  const lines = text.split('\n')
  const out: string[] = []
  let inFence = false
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]!
    if (FENCE.test(line)) inFence = !inFence
    if (inFence || !PRAGMA.test(line)) {
      out.push(line)
      continue
    }
    // the script runs to the first sentence, list or fence; blank lines before that stay out
    let end = i + 1
    while (end < lines.length && !FENCE.test(lines[end]!) && !isProse(lines[end]!)) end++
    let last = end
    while (last > i + 1 && !lines[last - 1]!.trim()) last--
    out.push('```edgescript', ...lines.slice(i, last), '```', ...lines.slice(last, end))
    i = end - 1
  }
  return out.join('\n')
}
